import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiFileText,
    title: "Knowledge-First Training",
    description: "Create chatbots that leverage your existing documents, PDFs, and technical content with no-code. Simply upload your event guide and Scotty learns instantly."
  },
  {
    icon: FiIcons.FiZap,
    title: "Instant Deployment",
    description: "Kickstart by inserting an example system prompt. No complex training loops or data science degrees required. Go from zero to live in minutes."
  },
  {
    icon: FiIcons.FiTrendingUp,
    title: "Sales Acceleration",
    description: "Custom AI chatbots to help you boost sales and cut costs with increased conversions. Let Scotty handle the FAQs while you close the VIP deals."
  },
  {
    icon: FiIcons.FiFilter,
    title: "Noise Reduction",
    description: "Filter out the noise and repetitive questions. Scotty identifies high-intent leads so your support team can focus on your true fans only."
  },
  {
    icon: FiIcons.FiPieChart,
    title: "Enriched Segmentation",
    description: "Capture and export leads with enriched data points for better segmentation. Understand attendee needs before the event even starts."
  },
  {
    icon: FiIcons.FiShare2,
    title: "Omnichannel Reach",
    description: "Integrate with Messenger, WhatsApp and directly to you Event Page for a wider audience. Be wherever your attendees are."
  }
];

const ScottyFeatures = () => {
  return (
    <section className="py-24 bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-violet-600 tracking-wide uppercase">AI Capabilities</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            The Smartest Support Member on Your Team
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-3xl border border-slate-200 hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="mb-6 inline-flex items-center justify-center p-3 bg-violet-600 rounded-2xl shadow-lg group-hover:rotate-12 transition-transform">
                <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScottyFeatures;